import React, { Component, Fragment } from 'react';
import { ModalBody, ModalFooter } from 'reactstrap';
import classNames from 'classnames';
import AddActionButton from '../AddActionButton';
import FormattedProperty from '../FormattedProperty';
import ListActionSubheader from '../ListActionSubheader';
import PropertyActions from '../PropertyActions';
import Modal from '../../../../shared/ui/Modal';

class AddressList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDeleteMessage: '',
      deleteIndex: -1,
      isModalOpen: false,
    };
  }

  // ----------------------
  // Computed
  // ----------------------

  getAddressPropertyActions(isDefault) {
    const editAddress = {
      label: 'Edit',
      handlerProp: 'onEdit',
      icon: 'edit',
    };
    const setDefault = {
      label: 'Set Default',
      handlerProp: 'onSetDefault',
      icon: 'check',
    };
    const deleteAddress = {
      label: 'Delete',
      handlerProp: 'onDelete',
      icon: 'trash',
    };
    return isDefault ? [editAddress] : [setDefault, editAddress, deleteAddress];
  }

  // ----------------------
  // Methods
  // ----------------------

  confirmDeleteAddress(deleteIndex) {
    const addressToDelete = this.props.addresses.find((address, arrayIndex) => {
      return arrayIndex === deleteIndex;
    });
    this.setState({
      confirmDeleteMessage: `Delete address labelled "${
        addressToDelete.label
      }"?`,
      deleteIndex,
      isModalOpen: true,
    });
  }

  deleteAddress(deleteIndex) {
    this.setState({
      confirmDeleteMessage: '',
      deleteIndex: -1,
      isModalOpen: false,
    });
    this.props.onDelete(deleteIndex);
  }

  // ----------------------
  // Render
  // ----------------------
  render() {
    return (
      <Fragment>
        <ListActionSubheader title="Addresses">
          { this.props.canAddEdit !== false &&
            <AddActionButton label="Address" onAdd={() => this.props.onAdd()} />
          }
        </ListActionSubheader>
        <div className="profile-list">
          {this.props.addresses.length > 0 ? (
            this.props.addresses.map((address, index) => (
              <div
                className={classNames('profile-list-item', {
                  'is-default': address.isDefault,
                })}
                key={index.toString()}
              >
                <div className="profile-list-item-selected">
                  <i className="fa fa-check" />
                </div>
                <div className="profile-list-content">
                  <FormattedProperty
                    type="address"
                    label={address.label}
                    value={address}
                  />
                </div>
                <div className="profile-list-actions">
                  {this.props.canAddEdit !== false &&
                    <PropertyActions
                      actions={this.getAddressPropertyActions(address.isDefault)}
                      onDelete={() => this.confirmDeleteAddress(index)}
                      onEdit={() => this.props.onEdit(index)}
                      onSetDefault={() => this.props.onSetDefault(index)}
                    />
                  }

                </div>
              </div>
            ))
          ) : (
            <div className="profile-list-item">No addresses found</div>
          )}
        </div>
        <Modal
          isOpen={this.state.isModalOpen}
          onClose={() => this.setState({ isModalOpen: false })}
          title="Confirm Delete Address"
        >
          <ModalBody>{this.state.confirmDeleteMessage}</ModalBody>
          <ModalFooter>
            <button
              className="button primary"
              onClick={() => this.deleteAddress(this.state.deleteIndex)}
            >
              Delete
            </button>
            <button
              className="button"
              onClick={() => this.setState({ isModalOpen: false })}
            >
              Cancel
            </button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

export default AddressList;
